import { render, staticRenderFns } from "./QuestionFooter.vue?vue&type=template&id=523b8a15"
import script from "./QuestionFooter.vue?vue&type=script&lang=js"
export * from "./QuestionFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports